/**
 * Naming constants for product-facing result terms.
 *
 * These were refactored when making some result name changes. This is not ideal because we don't have a
 * good way to enforce using these going forward and it goes against our existing naming strategies of using
 * capwords and pluralize functions. However, this is step in the direction of making future renames and
 * internationalization easier. Plus, it's pretty easy to grep and replace this with something else.
 */

// Name for the broad "Result" product, which includes concepts like Result and Run
export const RESULT_PRODUCT = 'Result';
export const RESULT_PRODUCT_SCHEMAS = `${RESULT_PRODUCT} schemas`;

export const MODEL_NAMES = {
  Result_Table: 'Result Table',
  Result_table: 'Result table',
  result_table: 'result table',
  result_tables: 'result tables',
  Result: 'Result',
  result: 'result',
  Results: 'Results',
  results: 'results',
  Run: 'Run',
  Runs: 'Runs',
  run: 'run',
  runs: 'runs',
};
